import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { defaultServices } from "~/services";
import { BaseQuery } from "~/@types";
import { Retail } from "~/features/retail";

export const fetchListRetail = async (q: BaseQuery) => {
  const res = await defaultServices.getList<Retail>({
    resource: "/retail",
    query: {
      ...q,
    },
  });

  return res;
};

export const getListRetail = (q: BaseQuery) =>
  queryOptions({
    queryKey: ["retail", { ...q }],
    queryFn: () => fetchListRetail(q),
    placeholderData: keepPreviousData,
  });
